import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

if (document.getElementById('page-talk')) {
  pageTalk()
}

function pageTalk() {
  //  #####     ###               ####   ####  #####
  //  ##  ##   ## ##             ##     ##     ##  ##
  //  #####   ##   ##  ########   ###   ##     #####
  //  ##      #######               ##  ##     ##  ##
  //  ##      ##   ##            ####    ####  ##   ##

  /*

      <div id="mvBox" class="js-scrollZoom mvBox anime chain fade-in wave4">
          <div class="mvBox__item">
              <div id="topMv" class="swiper-container">

              </div>
          </div>
      </div>

*/
  scrollParallax()
  function scrollParallax() {
    if (!document.getElementsByClassName('js-scrollSlide')[0]) {
      return
    }
    gsap.registerPlugin(ScrollTrigger) // スクロールトリガー起動

    gsap.utils.toArray('.js-scrollSlide').forEach((wrap) => {
      const x = wrap.dataset.x || '50%' // data-yからパララックス量取得
      gsap.to(wrap, {
        x: x,
        scrollTrigger: {
          trigger: wrap, // ターゲット要素
          start: 'top bottom', // 開始位置
          end: 'bottom top', // 終了位置
          scrub: 1, // 補正倍率
          // markers: true, // デバッグ表示
        },
      })
    })
  }

  //  #####    ####              #####  ##  ##    ##
  //  ##  ##  ##                 ##     ##   ##  ##
  //  #####   ##  ###  ########  #####  ##    ####
  //  ##  ##  ##   ##            ##     ##   ##  ##
  //  #####    ####              ##     ##  ##    ##

  // scrollBgFix()

  // function scrollBgFix() {
  //   const itemList = document.getElementsByClassName('js-scrollFix')
  //   if (!itemList[0]) {
  //     return
  //   }
  //   let isExecute = false // 実行中フラグ

  //   document.addEventListener('scroll', function (ev) {
  //     scrollValToggleApply()
  //   })
  //   document.addEventListener('touchstart', function (ev) {
  //     scrollValToggleApply()
  //   })
  //   document.addEventListener('touchmove', function (ev) {
  //     scrollValToggleApply()
  //   })
  //   document.addEventListener('touchend', function (ev) {
  //     scrollValToggleApply()
  //   })

  //   setInterval(() => {
  //     scrollValToggleApply() // 初回起動
  //   }, 1)

  //   scrollValToggleApply() // 初回起動
  //   function scrollValToggleApply() {
  //     if (isExecute) {
  //       // 実行中ならスキップ
  //       return
  //     }
  //     isExecute = true
  //     // レンダリング準備が整ったら開始
  //     requestAnimationFrame(function () {
  //       for (const item of itemList) {
  //         const target = item.querySelector('.js-scrollFix--target')

  //         const move = String(item.getBoundingClientRect().top * -1)

  //         if (move === target.dataset.move) {
  //           // 補正が不要ならスキップ
  //           continue
  //         }
  //         target.style.transform = 'translateY(' + move + 'px)'
  //         target.dataset.move = move
  //       }
  //       isExecute = false
  //     })
  //   }
  // }

  //   ####   ####            ######   #####    ####     ####    ##      #####
  //  ##     ##                 ##    ##   ##  ##       ##       ##      ##
  //   ###   ##     ########    ##    ##   ##  ##  ###  ##  ###  ##      #####
  //     ##  ##                 ##    ##   ##  ##   ##  ##   ##  ##      ##
  //  ####    ####              ##     #####    ####     ####    ######  #####

  /**
   * @function scrollValToggle
   * @description スクロール量を基準にクラスを着脱する
   * @param {String} targetSelector ターゲットとする一意なセレクタ
   * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
   * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
   * @param {String} toggleClass 切り替えるクラス名
   * @return {Void}
  scrollValToggle('#fixNav', 500, false,'active')
  */

  const navPoint = document.getElementById('secStart').getBoundingClientRect().top + window.scrollY

  scrollValToggle('#fixNav', navPoint, false, 'active')
  function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
    if (!document.querySelector(targetSelector)) {
      return
    }
    let isExecute = false // 実行中フラグ
    let scrollY = 0 // 縦方向のスクロール量
    const target = document.querySelector(targetSelector) // ターゲット要素
    let scToggleActive = false // ターゲット要素のONOFF状態
    document.addEventListener('scroll', function (ev) {
      scrollValToggleApply()
    })
    scrollValToggleApply() // 初回起動
    function scrollValToggleApply() {
      if (isExecute) {
        // 実行中ならスキップ
        return
      }
      isExecute = true
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        scrollY = window.pageYOffset // スクロール量
        if (scrollY >= scrollValStart && !scToggleActive) {
          //トップから指定px以上スクロールしたらON
          target.classList.add(toggleClass)
          scToggleActive = true
        } else if (scrollY < scrollValStart && scToggleActive) {
          //スクロールが足りない時はOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
        if (scrollValEnd && scToggleActive) {
          // 終了ラインが設定されている場合は終了判定
          if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
            //スクロール終了範囲を過ぎていたらOFF
            target.classList.remove(toggleClass)
            scToggleActive = false
          }
        }
        isExecute = false
      })
    }
  }
}
